import React from 'react';
import OtherAssets from "./OtherAssets";

const OtherAssetsCustomerView = props => {
  return (
    <OtherAssets customerId={props.auth.user.customer_id} />
  )
};

export default OtherAssetsCustomerView;